import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store = new Vuex.Store({
    state: {
        account:''
    },
    mutations: {
        addAccount(state, account) {
             
            state.account = account;
         }
    },
    actions: {
       
    }
})
export default store;


// WEBPACK FOOTER //
// ./src/store/store.js